/** Questionnaire-v1 reporting aliases. Q37 alone determines migration status.
 * Server SQL and browser report adapters consume the same classification map. */
export const residentTypeAliases = {
    NON_MIGRANT: ["1", "1nonmigrant", "nonmigrant"],
    MIGRANT: ["2", "2migrant", "migrant"],
    TRANSIENT: ["3", "3transient", "transient"],
    NOT_APPLICABLE: ["99", "99na", "99notapplicable", "na", "notapplicable"],
};
export const residentSexAliases = {
    Male: ["1", "1male", "male", "lalaki", "lalake"],
    Female: ["2", "2female", "female", "babae", "babaye"],
};
export function normalizeResidentCode(value) { return String(value ?? "").trim().toLowerCase().replace(/[^a-z0-9]+/g, ""); }
export function classifyResidentSex(value) {
    const code = normalizeResidentCode(value);
    return Object.entries(residentSexAliases).find(([, aliases]) => aliases.includes(code))?.[0] ?? null;
}
export function classifyResidentType(value) {
    const code = normalizeResidentCode(value);
    const key = Object.entries(residentTypeAliases).find(([, aliases]) => aliases.includes(code))?.[0];
    const labels = { NON_MIGRANT: "Non-Migrant", MIGRANT: "Migrant", TRANSIENT: "Transient", NOT_APPLICABLE: "N/A" };
    return key ? labels[key] : "Unclassified";
}
//# sourceMappingURL=resident-classification.js.map